<template>
  <section>

    <div class="pro_part">
      <div class="content__pro">
        <!-- //TITLE DESKTOP -->
        <div class="desktop">
          <h1>PRO</h1>
          <div class="select__wrapper">
            <font-awesome-icon :icon="['far', 'chevron-down']" />
            <b-form-select v-model="selectedPro" :options="prosDropDown" class="select">
            </b-form-select>
          </div>
          <div class="pro_buttons">
            <a v-if="downloadSignedProLink" :href="downloadSignedProLink" target="_blank" class="bt">
              Pro signé <i class="fas fa-file-pdf"></i>
            </a>
            <a v-if="downloadLink" :href="downloadLink" target="_blank" class="bt">
              CGV signé <i class="fas fa-file-pdf"></i>
            </a>
            <div v-if="proData.state === 'validate' && dates.length > 0" style="display: flex; align-items: center;">
              <p><b>Dates :</b></p>
              <div class="select__wrapper date">
                <font-awesome-icon :icon="['far', 'chevron-down']" />
                <b-form-select v-model="dateSelected" :options="dates" class="select">
                </b-form-select>
              </div>
            </div>
          </div>
        </div>
        <!-- //TITLE DESKTOP -->
      </div>

      <div class="download-pro" v-if="proData.state === 'wait_sign'">
        <p>Vous avez validé vos pro, Bravo ! <span style="color: #F08F2E; cursor: pointer" v-on:click="downloadUserProForSign()">Télécharger, signer vos PRO <i class="pr-2 fas fa-file-pdf"></i></span>et déposer les ci-dessous.</p>
        <div class="dropzone_button">
          <vue-dropzone ref="myVueDropzone" :useCustomSlot="true" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="dropzoneSuccess" v-on:vdropzone-error="dropzoneError">
            <div class="dropzone-custom-content">
              <div class="subtitle"><i class="fas fa-file-pdf"></i> Téléverser vos PRO signé</div>
            </div>
          </vue-dropzone>
          <b-button
              @click="sendSignedPro()"
              class="btn-download"
              :class="{disabled:isLoading}"
          >
            Envoyer
          </b-button>
        </div>
      </div>

      <div class="waiting-validate-pro" v-if="proData.state === 'waiting'">
        <p>Vos PRO ont bien été envoyées et sont en attente de validation par l’administrateur. Une fois valider vous pourrez voir vos résultats !</p>
      </div>

      <div class="pro-validate-no-result" v-if="proData.state === 'validate' && dates.length === 0">
        <p>Vos PRO ont bien été validées. Vos premiers résultats seront visibles d'ici 7 jours.</p>
      </div>

      <div v-if="proData.state === 'validate' && dates.length > 0">
          <wrapper-p-r-o-list  v-for="(value,index) in proData.userProUserProObjectives" :key="`${index}-pro`"
                               class="mb-4"
                               :lists="value.userProObjectives"
                               :name="value.proCategory.name"
                               :isLoad.sync = "getIsLoading"
          />

          <div class="block__totalPoints" v-if="Object.values(proData).length > 0">
            <p class="title">Estimation de prime</p>
            <p class="number">
              <PuSkeleton :loading="getIsLoading" :count="1" width='60px'>
                {{ getTotalPrime }}
              </PuSkeleton>
            </p>
          </div>
      </div>

      <div v-else>
        <wrapper-p-r-o-draft  v-for="(value,index) in proData.userProUserProObjectives" :key="`${index}-pro`"
                              class="mb-4"
                              :lists="value.userProObjectives"
                              :agents="agentsDropDown"
                              :name="value.proCategory.name"
                              :isLoad.sync = "getIsLoading"
                              :userProUserProObjectivesIndex = "index"
                              :readonly = "proData.state === 'wait_sign' || proData.state === 'waiting' || proData.state === 'validate'"
        />
      </div>



      <div v-if="prosDropDown.length === 0" class="text-center">
        <PuSkeleton :loading="getIsLoading" :count="1" width='160px'>
          Aucune données PRO
        </PuSkeleton>
      </div>

      <div class="pro-btn" v-if="proData.state === 'draft' || proData.state === 'refused'">
        <b-button
            @click="saveUserPro(false)"
            class="btn-outline"
            :class="{disabled:isLoading}"
        >
          Enregistrer
        </b-button>

        <b-button
            @click="showModal()"
            ref="btnShow"
            class="btn-primary"
            :class="{disabled:isLoading}"
        >
          Valider pour signature
        </b-button>
      </div>

      <validateForSignProModal
          @send="handleModal"
      >
      </validateForSignProModal>

      <send-signed-pro-modal
          @send="handleSignedProModal"
      >
      </send-signed-pro-modal>


      <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->
      <transition name="slide">
        <keep-alive>
          <router-view class="transition"></router-view>
        </keep-alive>
      </transition>
      <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->

      <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->
      <transition name="modal">
        <keep-alive>
          <router-view name="helper" class="myModal"></router-view>
        </keep-alive>
      </transition>
      <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->


    </div>
  </section>
</template>


<script>
import { mapGetters } from 'vuex'
import ParentMixin from '../../ParentMixin'
import CatMixin from '../../category/CatMixin'
import ApiService from "@/services/ApiService";
import ApiAuthenticationService from "@/services/ApiAuthenticationService";
import WrapperPRODraft from "@/components/module/wrapper/wrapperPRODraft.vue";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import validateForSignProModal from "@/components/module/modal/ValidateForSignProModal.vue";
import WrapperPROList from "@/components/module/wrapper/wrapperPROList.vue";
import sendSignedProModal from "@/components/module/modal/SendSignedProModal.vue";
import apiService from "@/services/ApiService";


export default {
  name:"objectiveHome",
  components:{
    WrapperPROList,
    validateForSignProModal,
    sendSignedProModal,
    WrapperPRODraft,
    vueDropzone: vue2Dropzone
    //    WrapperPROList
  },
  mixins: [
    ParentMixin,
    CatMixin
  ],
  computed: {
    ApiAuthenticationService() {
      return ApiAuthenticationService
    },
    apiService() {
      return apiService
    },
    ...mapGetters([
      'getProductionCardObjectiveChart',
      'getGeneral',
      'getPageTransition',
    ]),
    getIsLoading(){
      if(this.isLoading){
        return true;
      } else {
        return this.currentUserType === 'CONFIG_NATIONAL' && !this.actualUser;
      }
    },
    getTotalPrime(){
      let cpt = 0;
      for (let data of this.proData.userProUserProObjectives){
        cpt += data.userProObjectives
            .map( v => v.userProTrackingNumbers[0] ? v.userProTrackingNumbers[0].currentPrime : 0 )
            .reduce( (sum, current) => sum + current, 0 );
      }
      return Math.round(Math.floor(cpt)).toLocaleString();
    }
  },
  async created (){
    this.content = this.getGeneral;
    this.isLoading = true;

    let promises = [];

    promises.push(
        ApiService.getProApi().list().then((data) => {
          this.pros = data.data;
          if (this.pros.length > 0) {
            for (const pro of this.pros) {
              this.prosDropDown.push({value: pro, text: pro.title});
            }
            this.selectedPro = this.pros[0];
            if (this.selectedPro) {
              this.downloadLink = ApiService.getMediaApi().get(this.selectedPro.cgv.id);
              ApiService.getProApi().listDates(this.selectedPro.id, ApiAuthenticationService.getCurrentUser().id).then((data) => {
                this.dates = data.data;
                if (this.dates.length > 0) {
                  this.dateSelected = this.dates[0]['value'];
                }
              })
            } else {
              this.downloadLink = null;
            }
          }
        })
    );

    promises.push(
        ApiService.getCommercialApi().getCommercialsList(
            ApiAuthenticationService.getCurrentUser().id,
            'agent'
        ).then((data) => {
          this.agents = data.data;
          if (this.agents.length > 0) {
            for (const agent of this.agents) {
              this.agentsDropDown.push({value: agent.id, text: agent.fullName});
            }
          }
        })
    );

    Promise.all(promises).then(() => {
      if (this.selectedPro) {
        this.getData().then(() => { this.isLoading = false})
      } else {
        this.isLoading = false;
      }
    });

  },
  data () {
    return {
      cards: [],
      content: [],
      isLoading:true,
      selected: null,
      proData: [],
      dates: [],
      dateSelected: null,
      selectedPro: null,
      proSignedFile: null,
      downloadProLink: null,
      pros: [],
      prosDropDown: [],
      agents: [],
      agentsDropDown: [],
      downloadLink: '',
      downloadSignedProLink: null,
      dropzoneOptions: {
        url: process.env.VUE_APP_API_URI + '/api/media',
        maxFilesize: 20,
        acceptedFiles: 'application/pdf',
        addRemoveLinks: true,
        maxFiles: 1,
        withCredentials: false,
        dictRemoveFile: 'Supprimer',
        dictCancelUpload: '',
        headers : {
          Authorization: 'Bearer ' + ApiAuthenticationService.getAccessToken(),
          'Cache-Control': null,
          'X-Requested-With': null,
          Accept: null,
        }
      }
    }
  },
  methods : {
    handleModal(value) {
      if (value === true) {
        this.saveUserPro(true);
      }
    },
    showModal() {
      this.$bvModal.show('validate-for-sign-pro-modal');
    },
    async getData(){
      if (!this.selectedPro) {
        return;
      }
      this.proData = [];

      let promises = [];

      promises.push(
          ApiService.getProApi().getDetail(
              this.selectedPro.id,
              ApiAuthenticationService.getCurrentUser().id,
              this.dateSelected
          ).then((data) => {
            this.proData = data.data;
            if (this.proData.signedPro) {
              this.downloadSignedProLink = ApiService.getMediaApi().get(this.proData.signedPro.id);
            } else {
              this.downloadSignedProLink = null;
            }
          })
      );

      await Promise.all(promises);
    },
    saveUserPro(forSign) {
      var dataToSend = JSON.parse(JSON.stringify(this.proData));
      this.isLoading = true;

      for (const userProUserProObjectives of dataToSend.userProUserProObjectives) {
        for (const userProObjectives of userProUserProObjectives.userProObjectives) {
          if (userProObjectives.agents.length === 0) {
            continue;
          }
          let goodAgents= [];
          for (const agent of userProObjectives.agents) {
            if (agent.id) {
              goodAgents.push(agent.id);
            } else {
              goodAgents.push(agent);
            }
          }
          userProObjectives.agents = goodAgents;
        }
      }

      if (forSign) {
        dataToSend.state = 'wait_sign';
      } else {
        dataToSend.state = 'draft';
      }
      ApiService.getProApi().patchUserPro(
          this.selectedPro.id,
          ApiAuthenticationService.getCurrentUser().id,
          dataToSend
      ).then(() => {
        this.isLoading = false;
        this.getData();
      }, () => {this.isLoading = false;})
    },
    sendSignedPro() {
      this.$bvModal.show('send_signed_pro_modal');
    },
    handleSignedProModal(value) {
      if (value === true) {
        if (!this.proSignedFile) {
          return;
        }
        this.isLoading = true;

        var dataToSend = JSON.parse(JSON.stringify(this.proData));

        for (const userProUserProObjectives of dataToSend.userProUserProObjectives) {
          for (const userProObjectives of userProUserProObjectives.userProObjectives) {
            if (userProObjectives.agents.length === 0) {
              continue;
            }
            let goodAgents= [];
            for (const agent of userProObjectives.agents) {
              if (agent.id) {
                goodAgents.push(agent.id);
              } else {
                goodAgents.push(agent);
              }
            }
            userProObjectives.agents = goodAgents;
          }
        }
        ApiService.getProApi().patchUserPro(
            this.selectedPro.id,
            ApiAuthenticationService.getCurrentUser().id,
            { ...dataToSend, signedPro: this.proSignedFile, state: 'waiting' }
        ).then(() => {
          this.isLoading = false;
          this.getData();
        }, () => {this.isLoading = false;})
      }
    },
    dropzoneSuccess(file, response){
      this.proSignedFile = response.id;
    },
    dropzoneError(){
      this.$bvToast.toast('Une erreur est survenu', {
        title: `erreur`,
        solid: true,
        variant: 'error',
        toaster: 'b-toaster-top-center'
      })
      this.$refs.myVueDropzone.removeAllFiles(true);
    },
    downloadUserProForSign(){
      this.apiService.getProApi().downloadUserPro(this.selectedPro.id, ApiAuthenticationService.getCurrentUser().id)
          .then((res) => {
            const newBlob = new Blob([res.data], { type: 'pdf' });

            if (window.navigator && (window.navigator).msSaveOrOpenBlob) {
              (window.navigator).msSaveOrOpenBlob(newBlob);
              return;
            }

            const data = window.URL.createObjectURL(newBlob);

            const link = document.createElement('a');
            link.href = data;
            link.download = 'pro.pdf';

            link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
            setTimeout(() => {
              window.URL.revokeObjectURL(data);
              link.remove();
            }, 100);
          });
    }
  },
  watch: {
    $route() {
      this.getData(false).then(() => {
        this.isLoading = false;
      });
      this.$store.dispatch('showFooter',true);
    },
    'dateSelected' : function(){
      this.isLoading = true;
      this.getData().then(() => {
        this.isLoading = false;
      });
    },
    'selectedPro' : function(){
      this.isLoading = true;
      this.downloadLink = ApiService.getMediaApi().get(this.selectedPro.cgv.id);
      ApiService.getProApi().listDates(this.selectedPro.id, ApiAuthenticationService.getCurrentUser().id).then((data) => {
        this.dates = data.data;
        if (this.dates.length > 0) {
          this.dateSelected = this.dates[0]['value'];
        } else {
          this.dateSelected = null;
        }
        this.getData().then(() => {
          this.isLoading = false;
        });
      })
    },
  }
};
</script>
